import { render, staticRenderFns } from "./RChart.vue?vue&type=template&id=cef06bae&scoped=true"
import script from "./RChart.vue?vue&type=script&lang=ts"
export * from "./RChart.vue?vue&type=script&lang=ts"
import style0 from "./RChart.vue?vue&type=style&index=0&id=cef06bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef06bae",
  null
  
)

export default component.exports